import axios from "@/libs/api.request";
// 获取列表
export const getCostCurrency = params => {
  return axios.request({
    url: "/finance/CostCurrency",
    method: "get",
    params
  });
};
// 创建列表
export const add = data => {
  return axios.request({
    url: "/finance/CostCurrency",
    data,
    method: "post"
  });
};
// 获取详情
export const getDetails = id => {
  return axios.request({
    url: `/finance/CostCurrency/${id}`,
    method: "GET"
  });
};
// 更新列表
export const update = data => {
  return axios.request({
    url: `/finance/CostCurrency/${data.id}`,
    method: "put",
    data
  });
};

// 删除列表
export const del = id => {
  return axios.request({
    url: `/finance/CostCurrency/${id}`,
    method: "DELETE"
  });
};

// 汇率
export const ratePut = data => {
  return axios.request({
    url: `/finance/CostCurrency/${data.id}/${data.type}`,
    method: "put",
    data
  });
};

// 获取汇率记录列表
export const getCostCurrencyRate = params => {
  return axios.request({
    url: "/finance/CostCurrencyRate",
    method: "get",
    params
  });
};
// 创建列表
export const addCostCurrencyRate = data => {
  return axios.request({
    url: "/finance/CostCurrencyRate",
    data,
    method: "post"
  });
};
// 获取详情
export const getCostCurrencyRateDetail = id => {
  return axios.request({
    url: `/finance/CostCurrencyRate/${id}`,
    method: "GET"
  });
};
// 更新列表
export const updateCostCurrencyRate = data => {
  return axios.request({
    url: `/finance/CostCurrencyRate/${data.id}`,
    method: "put",
    data
  });
};

// 删除列表
export const delCostCurrencyRate = id => {
  return axios.request({
    url: `/finance/CostCurrencyRate/${id}`,
    method: "DELETE"
  });
};
